import { Box } from '@mui/material';
import { ACTIVITY_TABLE_COLUMNS } from '../../constants/activity';
import { Copy } from '../../copy/Copy';
import { addActivityIcons } from '../../helpers/addActivityIcons';
import {
  marginTop24Sx,
  noDataMessageContainerSx,
} from '../../styles/Global.style';
import { Table } from '../Table/Table';
import { Text } from '../Text/Text';
import { ModalContainer } from '../../containers/ModalContainer/ModalContainer';
import { Confirmation } from '../Confirmation/Confirmation';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { Loading } from '../Loading/Loading';
import { useUser } from '../../hooks/useUser/useUser';
import { useState } from 'react';
import { deleteActivity } from '../../helpers/deleteActivity';

export const Activities = () => {
  const { user } = useAuth();
  const { userData, isUserLoading } = useUser();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [activityId, setActivityId] = useState();

  const toggleDeleteModal = ({ activityId }) => {
    if (activityId) {
      setActivityId(activityId);
    }
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const handleDelete = async (e) => {
    e.preventDefault();

    await deleteActivity({
      jwt: user?.jwt,
      activityId: `${activityId}_${user.id}`,
    });
    location.reload();
  };

  return !isUserLoading ? (
    <>
      {userData.activities.length ? (
        <Table
          columns={ACTIVITY_TABLE_COLUMNS}
          rows={addActivityIcons(userData.activities)}
          allowDelete
          toggleDeleteModal={toggleDeleteModal}
          sx={marginTop24Sx}
        />
      ) : (
        <Box component="div" sx={noDataMessageContainerSx}>
          <Text text={Copy.generate('Profile.noActivity')} />
        </Box>
      )}

      <ModalContainer isOpen={isDeleteModalOpen} onClose={toggleDeleteModal}>
        <Confirmation
          title={Copy.generate('Global.areYouSure')}
          content={Copy.generate('Profile.deleteModal.content')}
          acceptBtnText={Copy.generate('Buttons.delete')}
          declineBtnText={Copy.generate('Buttons.back')}
          accept={handleDelete}
          decline={toggleDeleteModal}
        />
      </ModalContainer>
    </>
  ) : (
    <Loading />
  );
};
